import { useCallback, useEffect, useState } from "react";
import {
  Grid,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Box from "@mui/material/Box";
import CheckIcon from "@mui/icons-material/Check";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import BackButton from "components/shared/BackButton";
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
  StyledMenuItem,
} from "./AddProduct.style";
import DrawerCM from "components/shared/Drawer";
import { prodcutSchema, validateImg } from "validations";
import spliter from "helper/digit-spliter";
import {
  addProductRequest,
  getAllDesignRequest,
  getFilterCategoryRequest,
  getDesignRequest,
} from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import Toast from "helper/toast";
import { convertNum } from "helper/convert-num";
import Stack from "@mui/material/Stack";
import Autocomplete from "@mui/material/Autocomplete";
import Upload from "components/shared/Upload";
import ProgressBarCM from "components/shared/ProgressBar";
import Editor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

let types = [
  { id: 1, name: "مبلمان" },
  { id: 2, name: "اکسسوری" },
];

//////////////////////////
const formList = [
  { label: "نام محصول", type: "text", id: "title", required: true },
  { label: "لینک مقاله", type: "text", id: "link", required: false },
  {
    label: "قیمت همکار (تومان)",
    type: "text",
    id: "colleague_price",
    required: true,
  },
  {
    label: "قیمت (تومان)",
    type: "text",
    id: "before_discount_price",
    required: true,
  },
  {
    label: "تخفیف (درصد)",
    type: "text",
    id: "discount_percent",
    required: false,
    defaultValue: "0",
  },
  // { label: "توضیحات", type: "text", id: "description", required: false },
];

export default function AddProduct() {
  const [page, setPage] = useState(1);
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);
  const [category, setCategory] = useState({ data: [], count: 0 });
  const {
    register,
    handleSubmit,
    control,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(prodcutSchema),
  });
  const [image, setImage] = useState({ url: null, isChanged: false });
  const [userData, setUserData] = useState({});
  const [design, setDesign] = useState({ data: [], count: 0 });
  const [selectedCategory, setSelectedCategory] = useState({});
  const [selectedType, setSelectedType] = useState({});
  const [selectedDesign, setSelectedDesign] = useState({});
  const [isAmazing, setIsAmazing] = useState(false);

  ////// editor ////////
  const [content, setContent] = useState("");
  const handleChange = (content) => {
    setContent(content);
  };

  const getDesign = useCallback(async () => {
    const res = await request({
      url: getAllDesignRequest,
      values: {
        skip: 0,
        limit: 1000,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      category_id: items.category_id,
    }));

    setDesign({ data: transformedData, count: res.count });
  }, [page, request]);

  useEffect(() => {
    getDesign();
  }, [page, getDesign]);

  ////////////////// submit form /////////////////
  const onSubmit = async (data) => {
    if (!image.isChanged) return Toast({ type: "empty", title: "عکس محصول" });
    if (
      (getValues("discount_percent") &&
        convertNum(getValues("discount_percent")) > 100) ||
      !isFinite(convertNum(getValues("discount_percent")))
    ) {
      return Toast({
        type: "custom",
        title: "مقدار فیلد درصد باید فقط شامل عدد و پایین ۱۰۰ باشد",
      });
    }

    const res = await request({
      url: () =>
        addProductRequest({ image, ...data, content }, (progress) =>
          setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({ type: "success", title: "ثبت محصول" });
      reset({
        title: "",
        link: "",
        design_id: "",
        before_discount_price: "",
        colleague_price: "",
        discount_percent: "",
        description: "",
        amazing_offer: "",
      });
      setImage({ url: null, isChanged: false });
    }
  };

  const getCategory = useCallback(
    async (values) => {
      const res = await request({
        url: getFilterCategoryRequest,
        // values: {
        //   type: values.type,
        // },
      });

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        type: items.type,
      }));

      setCategory({ data: transformedData, count: res.count });
    },
    [request]
  );
  useEffect(() => {
    getCategory();
  }, [getCategory]);

  ///////////////// handle image ////////////////
  const handleChangeImage = (val) => {
    validateImg(val);
    setImage({ url: val, isChanged: true });
  };

  return (
    <DrawerCM title="افزودن محصول">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <Grid item mb={-2} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>افزودن محصول</StyledTitle>
            <Grid container>
              <Grid item md={6} xs={12} p={1}>
                <FormControl fullWidth>
                  <InputLabel id="select-type">سردسته</InputLabel>
                  <Select
                    labelId="select-type"
                    label="سردسته"
                    value={selectedType?.name}
                    // defaultValue={userData?.type}
                    id="type"
                    {...register("type")}
                    error={Boolean(errors.type)}
                    helpertext={errors.type?.message}
                    onChange={(e) =>
                      setSelectedType({
                        name: e.target.value,
                      })
                    }
                  >
                    {types?.map((item, index) => (
                      <MenuItem
                        key={index}
                        value={item.name}
                        style={{
                          direction: "rtl",
                        }}
                      >
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12} p={1}>
                <FormControl fullWidth>
                  <InputLabel id="select-category">زیردسته</InputLabel>
                  <Select
                    labelId="select-category"
                    label="زیردسته"
                    value={selectedCategory?.name}
                    // defaultValue={userData?.category}
                    id="category"
                    {...register("category")}
                    error={Boolean(errors.category)}
                    helpertext={errors.category?.message}
                    onChange={(e) => {
                      // console.log(selectedCategory);
                      setSelectedCategory({
                        name: e.target.value,
                      });
                    }}
                  >
                    {category.data
                      ?.filter(
                        (item) =>
                          item.type ===
                          types?.find((item) => item.name === selectedType.name)
                            ?.name
                      )
                      .map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item.id}
                          style={{
                            direction: "rtl",
                          }}
                        >
                          {item.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12} p={1}>
                <FormControl fullWidth>
                  <InputLabel id="select-design">طرح</InputLabel>
                  <Select
                    labelId="select-design"
                    label="طرح"
                    value={selectedDesign?.name}
                    // defaultValue={userData?.category}
                    id="design_id"
                    {...register("design_id")}
                    error={Boolean(errors.design_id)}
                    helpertext={errors.design_id?.message}
                    onChange={(e) =>
                      setSelectedDesign({
                        name: e.target.value,
                      })
                    }
                  >
                    {design.data?.length > 0 &&
                      design.data
                        ?.filter(
                          (item) =>
                            item.category_id ==
                            category.data?.find(
                              (item) => item.id == selectedCategory.name
                            )?.id
                        )
                        .map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item.id}
                            style={{
                              direction: "rtl",
                            }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </Grid>
              {formList.map((items, index) => (
                <Grid item md={6} xs={12} p={1} key={"add-product" + index}>
                  <TextField
                    id={items.id}
                    label={items.label}
                    variant="outlined"
                    required={items.required}
                    fullWidth
                    defaultValue={items.defaultValue}
                    multiline={items.id === "description"}
                    rows={items.id === "description" ? 6.4 : 1}
                    {...register(items.id)}
                    error={Boolean(errors[items.id])}
                    helperText={errors[items.id]?.message}
                  />
                </Grid>
              ))}

              <Grid item md={12} xs={12} p={1.5}>
                <Upload
                  isLocal={image.isChanged}
                  file={image.url}
                  refillable
                  type="add-product"
                  onChange={handleChangeImage}
                  width={"100%"}
                  height={"100%"}
                  objectFit="contain"
                />
              </Grid>
              <Grid item md={12} xs={12} p={1.5}>
                <Editor
                  enableToolbar={true}
                  // onChange={(text) => setContent(text)}
                  onChange={handleChange}
                  setDefaultStyle="font-family: IranSans; height: 40vh;"
                  setOptions={{
                    buttonList: buttonList.complex,
                    font: [
                      "IranSans",
                      "IranSansBold",
                      "Arial",
                      "Impact",
                      "Tahoma",
                    ],
                  }}
                />
              </Grid>
              <Grid item md={12} xs={12} p={1.5}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register("amazing_offer")}
                        checked={isAmazing}
                        onChange={(e) => {
                          setIsAmazing(e.target.checked);
                        }}
                      />
                    }
                    label="پیشنهاد ویژه"
                  />
                </FormGroup>
              </Grid>

              <ButtonContainer>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ثبت
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
